module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "forum-loader-after"
  }, [_c('hr', {
    staticClass: "hr-66"
  }), _vm._v(" "), _c('hr', {
    staticClass: "hr-33"
  }), _vm._v(" "), _c('Loader')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f501cb4c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reusable/forum/loader-after.vue
// module id = 2147
// module chunks = 2